const clampUnit = (value: number, fallback: number) =>
  Math.max(0, Math.min(1, Number.isFinite(value) ? value : fallback));

/**
 * Maps the user-facing slider position to the media element's linear gain.
 * A quadratic curve gives the quiet end substantially more usable travel while
 * preserving exact silence and full volume at the endpoints.
 */
export function sliderPositionToMediaVolume(position: number): number {
  const safePosition = clampUnit(position, 1);
  return safePosition * safePosition;
}

/** Converts linear media gain back to the user-facing perceptual slider. */
export function mediaVolumeToSliderPosition(volume: number): number {
  return Math.sqrt(clampUnit(volume, 1));
}

/** Steps volume in slider space so keys and wheels use the same curve. */
export function adjustMediaVolumeBySliderStep(
  volume: number,
  direction: -1 | 1,
  step = 0.05,
): number {
  const sliderPosition = mediaVolumeToSliderPosition(volume);
  const safeStep = Math.max(0, Number.isFinite(step) ? step : 0.05);
  return sliderPositionToMediaVolume(sliderPosition + direction * safeStep);
}
